module.exports = __webpack_public_path__ + "static/img/Fashion.12ab969.png";